// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Biometrics-module__font-s-10___AYicN {
  font-size: 10px !important;
}

.Biometrics-module__font-s-12___Sp9j5 {
  font-size: 12px !important;
}

.Biometrics-module__font-s-13___lRkXQ {
  font-size: 13px !important;
}

.Biometrics-module__font-s-14____iVLO {
  font-size: 14px !important;
}

.Biometrics-module__font-s-15___MsTfC {
  font-size: 15px !important;
}

.Biometrics-module__font-s-16___H2fCF {
  font-size: 16px !important;
}

.Biometrics-module__font-s-18___MyP2C {
  font-size: 18px !important;
}

.Biometrics-module__font-s-20___BXqAq {
  font-size: 20px !important;
}

.Biometrics-module__font-s-22___NQhfy {
  font-size: 22px !important;
}

.Biometrics-module__font-s-28___PMpip {
  font-size: 28px !important;
}

.Biometrics-module__font-w-400___OwPXj {
  font-weight: 400 !important;
}

.Biometrics-module__font-w-500___uAo5a {
  font-weight: 500 !important;
}

.Biometrics-module__font-w-600___fhQJi {
  font-weight: 600 !important;
}

.Biometrics-module__font-w-700___rfM2D {
  font-weight: 700 !important;
}

.Biometrics-module__p-5___qPj9b {
  padding: 5px !important;
}

.Biometrics-module__p-12___pbrNd {
  padding: 12px !important;
}

.Biometrics-module__p-16___uuOl7 {
  padding: 16px !important;
}

.Biometrics-module__p-30___jWEMx {
  padding: 30px !important;
}

.Biometrics-module__p-b-0___s25Jx {
  padding-bottom: 0 !important;
}

.Biometrics-module__p-b-5___lrhPG {
  padding-bottom: 5px !important;
}

.Biometrics-module__p-b-10___beCKk {
  padding-bottom: 10px !important;
}

.Biometrics-module__p-b-12___FFbKk {
  padding-bottom: 12px !important;
}

.Biometrics-module__p-b-16___NkKpa {
  padding-bottom: 16px !important;
}

.Biometrics-module__p-b-18___JoeWI {
  padding-bottom: 18px !important;
}

.Biometrics-module__p-b-20___hhuKm {
  padding-bottom: 20px !important;
}

.Biometrics-module__p-b-25___pYZHO {
  padding-bottom: 25px !important;
}

.Biometrics-module__p-b-30___wqGwQ {
  padding-bottom: 30px !important;
}

.Biometrics-module__p-b-50___F2SMm {
  padding-bottom: 50px !important;
}

.Biometrics-module__p-t-0___wBsXe {
  padding-top: 0 !important;
}

.Biometrics-module__p-t-12___sZiKr {
  padding-top: 12px !important;
}

.Biometrics-module__p-t-16___OGRSY {
  padding-top: 16px !important;
}

.Biometrics-module__p-t-18___NIxq9 {
  padding-top: 18px !important;
}

.Biometrics-module__p-t-20___WzPLE {
  padding-top: 20px !important;
}

.Biometrics-module__p-t-30___OXQ4d {
  padding-top: 30px !important;
}

.Biometrics-module__p-t-40___kuEvS {
  padding-top: 40px !important;
}

.Biometrics-module__p-t-50___VQQQd {
  padding-top: 50px !important;
}

.Biometrics-module__p-l-20___C_UiO {
  padding-left: 20px !important;
}

.Biometrics-module__p-l-30___vPmvs {
  padding-left: 30px !important;
}

.Biometrics-module__p-l-40___YlRtK {
  padding-left: 40px !important;
}

.Biometrics-module__p-r-16___wc9Il {
  padding-right: 16px !important;
}

.Biometrics-module__p-r-20____iSNi {
  padding-right: 20px !important;
}

.Biometrics-module__p-r-30___QSCYQ {
  padding-right: 30px !important;
}

.Biometrics-module__p-r-50___NcfWx {
  padding-right: 50px !important;
}

.Biometrics-module__p-r-60___VKyjb {
  padding-right: 60px !important;
}

.Biometrics-module__m-b-1___Fbpfc {
  margin-bottom: 1px !important;
}

.Biometrics-module__m-b-2___tWB1P {
  margin-bottom: 2px !important;
}

.Biometrics-module__m-b-6___qlU9r {
  margin-bottom: 6px !important;
}

.Biometrics-module__m-b-8___SyPdd {
  margin-bottom: 8px !important;
}

.Biometrics-module__m-b-10___GYy8e {
  margin-bottom: 10px !important;
}

.Biometrics-module__m-b-14___YZNWe {
  margin-bottom: 14px !important;
}

.Biometrics-module__m-b-16___kwXcx {
  margin-bottom: 16px !important;
}

.Biometrics-module__m-b-20___DaYQw {
  margin-bottom: 20px !important;
}

.Biometrics-module__m-b-22___hdS2x {
  margin-bottom: 22px !important;
}

.Biometrics-module__m-b-24___RolIh {
  margin-bottom: 24px !important;
}

.Biometrics-module__m-b-30___woK_Q {
  margin-bottom: 30px !important;
}

.Biometrics-module__m-b-32___geOsV {
  margin-bottom: 32px !important;
}

.Biometrics-module__m-b-40___dxaLR {
  margin-bottom: 40px !important;
}

.Biometrics-module__m-t-2___jZ6J7 {
  margin-top: 2px !important;
}

.Biometrics-module__m-t-3___IJgiw {
  margin-top: 3px !important;
}

.Biometrics-module__m-t-4___kjHKq {
  margin-top: 4px !important;
}

.Biometrics-module__m-t-5___wuZrs {
  margin-top: 5px !important;
}

.Biometrics-module__m-t-8___FIbrs {
  margin-top: 8px !important;
}

.Biometrics-module__m-t-10___eWwQk {
  margin-top: 10px !important;
}

.Biometrics-module__m-t-15___mu8ph {
  margin-top: 15px !important;
}

.Biometrics-module__m-t-16___Vfx10 {
  margin-top: 16px !important;
}

.Biometrics-module__m-t-20___eLvh7 {
  margin-top: 20px !important;
}

.Biometrics-module__m-t-22___Yiqkp {
  margin-top: 22px !important;
}

.Biometrics-module__m-t-30___vYAsj {
  margin-top: 30px !important;
}

.Biometrics-module__m-t-32___LLzkr {
  margin-top: 32px !important;
}

.Biometrics-module__m-l-auto___WeNyk {
  margin-left: auto !important;
}

.Biometrics-module__m-l-4___t0Qvv {
  margin-left: 4px !important;
}

.Biometrics-module__m-l-5___XGHwe {
  margin-left: 5px !important;
}

.Biometrics-module__m-l-6___TVAm_ {
  margin-left: 6px !important;
}

.Biometrics-module__m-l-8___xDX0w {
  margin-left: 8px !important;
}

.Biometrics-module__m-l-10___XDCcY {
  margin-left: 10px !important;
}

.Biometrics-module__m-l-16___OxN0R {
  margin-left: 16px !important;
}

.Biometrics-module__m-l-20___zNr83 {
  margin-left: 20px !important;
}

.Biometrics-module__m-l-24___V3bum {
  margin-left: 24px !important;
}

.Biometrics-module__m-l-30___JhaLX {
  margin-left: 30px !important;
}

.Biometrics-module__m-l-35___pqaiI {
  margin-left: 35px !important;
}

.Biometrics-module__m-l-40___K1zap {
  margin-left: 40px !important;
}

.Biometrics-module__m-r-8___BcQB9 {
  margin-right: 8px !important;
}

.Biometrics-module__m-r-10___mldCR {
  margin-right: 10px !important;
}

.Biometrics-module__m-r-16___aDX6Z {
  margin-right: 16px !important;
}

.Biometrics-module__m-r-20___e9H1_ {
  margin-right: 20px !important;
}

.Biometrics-module__m-r-24___BxKg8 {
  margin-right: 24px !important;
}

.Biometrics-module__m-r-30___dOhFi {
  margin-right: 30px !important;
}

.Biometrics-module__m-r-40___tpyeO {
  margin-right: 40px !important;
}

.Biometrics-module__border-r-3___juEcF {
  border-radius: 3px !important;
}

.Biometrics-module__border-r-4___LWw_8 {
  border-radius: 4px !important;
}

.Biometrics-module__border-r-6___lFRqy {
  border-radius: 6px !important;
}

.Biometrics-module__border-r-10___grmyR {
  border-radius: 10px !important;
}

.Biometrics-module__border-r-12___MUynn {
  border-radius: 12px !important;
}

.Biometrics-module__border-r-16___UY1Eh {
  border-radius: 16px !important;
}

.Biometrics-module__border-r-50___iK7gW {
  border-radius: 50% !important;
}

.Biometrics-module__primary-border___G5h3l {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Biometrics-module__primary-border-b___sKwdb {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Biometrics-module__primary-border-t___mXCgO {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Biometrics-module__primary-border-l___bhW8G {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Biometrics-module__primary-border-r___iMwhM {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Biometrics-module__secondary-border___Z2AiX {
  border: 1px solid #637768;
}

.Biometrics-module__secondary-border-b___gvcXR {
  border-bottom: 1px solid #637768;
}

.Biometrics-module__secondary-border-t___OourW {
  border-top: 1px solid #637768;
}

.Biometrics-module__secondary-border-l___Bjg3r {
  border-left: 1px solid #637768;
}

.Biometrics-module__secondary-border-r___JWAjZ {
  border-right: 1px solid #637768;
}

.Biometrics-module__gap-0___cvjq6 {
  gap: 0 !important;
}

.Biometrics-module__gap-2___gJTqJ {
  gap: 2px !important;
}

.Biometrics-module__gap-4___lMdxY {
  gap: 4px !important;
}

.Biometrics-module__gap-5___uogeb {
  gap: 5px !important;
}

.Biometrics-module__gap-6___zpLfh {
  gap: 6px !important;
}

.Biometrics-module__gap-8___IHD1h {
  gap: 8px !important;
}

.Biometrics-module__gap-10___Ol2mc {
  gap: 10px !important;
}

.Biometrics-module__gap-12___Fmv3R {
  gap: 12px !important;
}

.Biometrics-module__gap-14___AGor3 {
  gap: 14px !important;
}

.Biometrics-module__gap-16___PJXiv {
  gap: 16px !important;
}

.Biometrics-module__gap-18___jzMwb {
  gap: 18px !important;
}

.Biometrics-module__gap-20___xhRTG {
  gap: 20px !important;
}

.Biometrics-module__gap-24___l7tjF {
  gap: 24px !important;
}

.Biometrics-module__gap-26___atohs {
  gap: 26px !important;
}

.Biometrics-module__gap-30___uPLT5 {
  gap: 30px !important;
}

.Biometrics-module__gap-32___C_CeP {
  gap: 32px !important;
}

.Biometrics-module__gap-40___iV9Qm {
  gap: 40px !important;
}

.Biometrics-module__gap-50___fRylZ {
  gap: 50px !important;
}

.Biometrics-module__flex-1___QQcpu {
  flex: 1;
}

.Biometrics-module__flex-none___z_MRn {
  flex: none !important;
}

.Biometrics-module__flex-column___k49_m {
  display: flex;
  flex-direction: column !important;
}

.Biometrics-module__flex-row___XCgVc {
  display: flex;
  flex-direction: row !important;
}

.Biometrics-module__vertically-centered___faDuk {
  display: flex;
  align-items: center !important;
}

.Biometrics-module__horizontally-centered___heXZC {
  display: flex;
  justify-content: center !important;
}

.Biometrics-module__horizontally-end___Sa0sL {
  display: flex;
  justify-content: end !important;
}

.Biometrics-module__vertically-start___iROFg {
  display: flex;
  align-items: start !important;
}

.Biometrics-module__space-between___MaFdW {
  display: flex;
  justify-content: space-between !important;
}

.Biometrics-module__flex-wrap___HC3NZ {
  flex-wrap: wrap !important;
}

.Biometrics-module__height-100___kbSSz {
  height: 100%;
}

.Biometrics-module__width-50___HY4eK {
  width: 50% !important;
}

.Biometrics-module__width-100___QTzy9 {
  width: 100%;
}

.Biometrics-module__cursor-pointer___GzfLg {
  cursor: pointer;
}

.Biometrics-module__cursor-not-allowed___hFJ0H {
  cursor: not-allowed !important;
}

.Biometrics-module__absolute-centered___VTfJ2 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Biometrics-module__absolute___gbW6y {
  position: absolute;
}

.Biometrics-module__relative___BZL89 {
  position: relative;
}

.Biometrics-module__fixed___kjKGB {
  position: fixed;
}

.Biometrics-module__visible___GEv6S {
  opacity: 1;
}

.Biometrics-module__invisible____A1i7 {
  opacity: 0;
}

.Biometrics-module__col-90___ktrfj {
  width: 90% !important;
}

.Biometrics-module__col-auto___YNB5S {
  width: auto !important;
}

.Biometrics-module__medical-tabs___xIzfv {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Biometrics-module__medical-table-new___mVN_g {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Biometrics-module__medical-table-new___mVN_g:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Biometrics-module__medical-table-new___mVN_g::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Biometrics-module__medical-table-new___mVN_g::-webkit-scrollbar-track {
  display: none;
}
.Biometrics-module__medical-table-new___mVN_g.Biometrics-module__no-pagination___ADBeN {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Biometrics-module__medical-table-new___mVN_g.Biometrics-module__no-pagination___ADBeN:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Biometrics-module__medical-table-new___mVN_g.Biometrics-module__no-pagination___ADBeN::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Biometrics-module__medical-table-new___mVN_g.Biometrics-module__no-pagination___ADBeN::-webkit-scrollbar-track {
  display: none;
}

.Biometrics-module__medical-table-empty___guJjK {
  padding: 14px 40px !important;
}

.Biometrics-module__icon-btn___sgQsA {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Biometrics-module__search-icon___yg3JC {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Biometrics-module__disable-select___T1Q8h {
  user-select: none;
}

.Biometrics-module__break-word___vvPWf {
  word-break: break-word;
}

.Biometrics-module__popup-clear-btn___iECWm {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Biometrics-module__scroll-m-b-20___xcs3D {
  scroll-margin-bottom: 20px;
}

.Biometrics-module__tabs___WXUKo {
  padding: 20px 30px;
}
.Biometrics-module__tabs___WXUKo button > div {
  min-width: auto;
}

.Biometrics-module__empty___Wrscf {
  display: flex;
  height: 60vh;
  align-items: center;
  justify-content: center;
  color: #375844;
  font-weight: 700;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/Biometrics.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;AA8pBF;AA5pBE;EACE,eAAA;AA8pBJ;;AA1pBA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.tabs {\n  padding: 20px 30px;\n\n  button > div {\n    min-width: auto;\n  }\n}\n\n.empty {\n  display: flex;\n  height: 60vh;\n  align-items: center;\n  justify-content: center;\n  color: get-color(greenNew, dark);\n  font-weight: 700;\n  font-size: 20px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Biometrics-module__font-s-10___AYicN`,
	"fontS12": `Biometrics-module__font-s-12___Sp9j5`,
	"fontS13": `Biometrics-module__font-s-13___lRkXQ`,
	"fontS14": `Biometrics-module__font-s-14____iVLO`,
	"fontS15": `Biometrics-module__font-s-15___MsTfC`,
	"fontS16": `Biometrics-module__font-s-16___H2fCF`,
	"fontS18": `Biometrics-module__font-s-18___MyP2C`,
	"fontS20": `Biometrics-module__font-s-20___BXqAq`,
	"fontS22": `Biometrics-module__font-s-22___NQhfy`,
	"fontS28": `Biometrics-module__font-s-28___PMpip`,
	"fontW400": `Biometrics-module__font-w-400___OwPXj`,
	"fontW500": `Biometrics-module__font-w-500___uAo5a`,
	"fontW600": `Biometrics-module__font-w-600___fhQJi`,
	"fontW700": `Biometrics-module__font-w-700___rfM2D`,
	"p5": `Biometrics-module__p-5___qPj9b`,
	"p12": `Biometrics-module__p-12___pbrNd`,
	"p16": `Biometrics-module__p-16___uuOl7`,
	"p30": `Biometrics-module__p-30___jWEMx`,
	"pB0": `Biometrics-module__p-b-0___s25Jx`,
	"pB5": `Biometrics-module__p-b-5___lrhPG`,
	"pB10": `Biometrics-module__p-b-10___beCKk`,
	"pB12": `Biometrics-module__p-b-12___FFbKk`,
	"pB16": `Biometrics-module__p-b-16___NkKpa`,
	"pB18": `Biometrics-module__p-b-18___JoeWI`,
	"pB20": `Biometrics-module__p-b-20___hhuKm`,
	"pB25": `Biometrics-module__p-b-25___pYZHO`,
	"pB30": `Biometrics-module__p-b-30___wqGwQ`,
	"pB50": `Biometrics-module__p-b-50___F2SMm`,
	"pT0": `Biometrics-module__p-t-0___wBsXe`,
	"pT12": `Biometrics-module__p-t-12___sZiKr`,
	"pT16": `Biometrics-module__p-t-16___OGRSY`,
	"pT18": `Biometrics-module__p-t-18___NIxq9`,
	"pT20": `Biometrics-module__p-t-20___WzPLE`,
	"pT30": `Biometrics-module__p-t-30___OXQ4d`,
	"pT40": `Biometrics-module__p-t-40___kuEvS`,
	"pT50": `Biometrics-module__p-t-50___VQQQd`,
	"pL20": `Biometrics-module__p-l-20___C_UiO`,
	"pL30": `Biometrics-module__p-l-30___vPmvs`,
	"pL40": `Biometrics-module__p-l-40___YlRtK`,
	"pR16": `Biometrics-module__p-r-16___wc9Il`,
	"pR20": `Biometrics-module__p-r-20____iSNi`,
	"pR30": `Biometrics-module__p-r-30___QSCYQ`,
	"pR50": `Biometrics-module__p-r-50___NcfWx`,
	"pR60": `Biometrics-module__p-r-60___VKyjb`,
	"mB1": `Biometrics-module__m-b-1___Fbpfc`,
	"mB2": `Biometrics-module__m-b-2___tWB1P`,
	"mB6": `Biometrics-module__m-b-6___qlU9r`,
	"mB8": `Biometrics-module__m-b-8___SyPdd`,
	"mB10": `Biometrics-module__m-b-10___GYy8e`,
	"mB14": `Biometrics-module__m-b-14___YZNWe`,
	"mB16": `Biometrics-module__m-b-16___kwXcx`,
	"mB20": `Biometrics-module__m-b-20___DaYQw`,
	"mB22": `Biometrics-module__m-b-22___hdS2x`,
	"mB24": `Biometrics-module__m-b-24___RolIh`,
	"mB30": `Biometrics-module__m-b-30___woK_Q`,
	"mB32": `Biometrics-module__m-b-32___geOsV`,
	"mB40": `Biometrics-module__m-b-40___dxaLR`,
	"mT2": `Biometrics-module__m-t-2___jZ6J7`,
	"mT3": `Biometrics-module__m-t-3___IJgiw`,
	"mT4": `Biometrics-module__m-t-4___kjHKq`,
	"mT5": `Biometrics-module__m-t-5___wuZrs`,
	"mT8": `Biometrics-module__m-t-8___FIbrs`,
	"mT10": `Biometrics-module__m-t-10___eWwQk`,
	"mT15": `Biometrics-module__m-t-15___mu8ph`,
	"mT16": `Biometrics-module__m-t-16___Vfx10`,
	"mT20": `Biometrics-module__m-t-20___eLvh7`,
	"mT22": `Biometrics-module__m-t-22___Yiqkp`,
	"mT30": `Biometrics-module__m-t-30___vYAsj`,
	"mT32": `Biometrics-module__m-t-32___LLzkr`,
	"mLAuto": `Biometrics-module__m-l-auto___WeNyk`,
	"mL4": `Biometrics-module__m-l-4___t0Qvv`,
	"mL5": `Biometrics-module__m-l-5___XGHwe`,
	"mL6": `Biometrics-module__m-l-6___TVAm_`,
	"mL8": `Biometrics-module__m-l-8___xDX0w`,
	"mL10": `Biometrics-module__m-l-10___XDCcY`,
	"mL16": `Biometrics-module__m-l-16___OxN0R`,
	"mL20": `Biometrics-module__m-l-20___zNr83`,
	"mL24": `Biometrics-module__m-l-24___V3bum`,
	"mL30": `Biometrics-module__m-l-30___JhaLX`,
	"mL35": `Biometrics-module__m-l-35___pqaiI`,
	"mL40": `Biometrics-module__m-l-40___K1zap`,
	"mR8": `Biometrics-module__m-r-8___BcQB9`,
	"mR10": `Biometrics-module__m-r-10___mldCR`,
	"mR16": `Biometrics-module__m-r-16___aDX6Z`,
	"mR20": `Biometrics-module__m-r-20___e9H1_`,
	"mR24": `Biometrics-module__m-r-24___BxKg8`,
	"mR30": `Biometrics-module__m-r-30___dOhFi`,
	"mR40": `Biometrics-module__m-r-40___tpyeO`,
	"borderR3": `Biometrics-module__border-r-3___juEcF`,
	"borderR4": `Biometrics-module__border-r-4___LWw_8`,
	"borderR6": `Biometrics-module__border-r-6___lFRqy`,
	"borderR10": `Biometrics-module__border-r-10___grmyR`,
	"borderR12": `Biometrics-module__border-r-12___MUynn`,
	"borderR16": `Biometrics-module__border-r-16___UY1Eh`,
	"borderR50": `Biometrics-module__border-r-50___iK7gW`,
	"primaryBorder": `Biometrics-module__primary-border___G5h3l`,
	"primaryBorderB": `Biometrics-module__primary-border-b___sKwdb`,
	"primaryBorderT": `Biometrics-module__primary-border-t___mXCgO`,
	"primaryBorderL": `Biometrics-module__primary-border-l___bhW8G`,
	"primaryBorderR": `Biometrics-module__primary-border-r___iMwhM`,
	"secondaryBorder": `Biometrics-module__secondary-border___Z2AiX`,
	"secondaryBorderB": `Biometrics-module__secondary-border-b___gvcXR`,
	"secondaryBorderT": `Biometrics-module__secondary-border-t___OourW`,
	"secondaryBorderL": `Biometrics-module__secondary-border-l___Bjg3r`,
	"secondaryBorderR": `Biometrics-module__secondary-border-r___JWAjZ`,
	"gap0": `Biometrics-module__gap-0___cvjq6`,
	"gap2": `Biometrics-module__gap-2___gJTqJ`,
	"gap4": `Biometrics-module__gap-4___lMdxY`,
	"gap5": `Biometrics-module__gap-5___uogeb`,
	"gap6": `Biometrics-module__gap-6___zpLfh`,
	"gap8": `Biometrics-module__gap-8___IHD1h`,
	"gap10": `Biometrics-module__gap-10___Ol2mc`,
	"gap12": `Biometrics-module__gap-12___Fmv3R`,
	"gap14": `Biometrics-module__gap-14___AGor3`,
	"gap16": `Biometrics-module__gap-16___PJXiv`,
	"gap18": `Biometrics-module__gap-18___jzMwb`,
	"gap20": `Biometrics-module__gap-20___xhRTG`,
	"gap24": `Biometrics-module__gap-24___l7tjF`,
	"gap26": `Biometrics-module__gap-26___atohs`,
	"gap30": `Biometrics-module__gap-30___uPLT5`,
	"gap32": `Biometrics-module__gap-32___C_CeP`,
	"gap40": `Biometrics-module__gap-40___iV9Qm`,
	"gap50": `Biometrics-module__gap-50___fRylZ`,
	"flex1": `Biometrics-module__flex-1___QQcpu`,
	"flexNone": `Biometrics-module__flex-none___z_MRn`,
	"flexColumn": `Biometrics-module__flex-column___k49_m`,
	"flexRow": `Biometrics-module__flex-row___XCgVc`,
	"verticallyCentered": `Biometrics-module__vertically-centered___faDuk`,
	"horizontallyCentered": `Biometrics-module__horizontally-centered___heXZC`,
	"horizontallyEnd": `Biometrics-module__horizontally-end___Sa0sL`,
	"verticallyStart": `Biometrics-module__vertically-start___iROFg`,
	"spaceBetween": `Biometrics-module__space-between___MaFdW`,
	"flexWrap": `Biometrics-module__flex-wrap___HC3NZ`,
	"height100": `Biometrics-module__height-100___kbSSz`,
	"width50": `Biometrics-module__width-50___HY4eK`,
	"width100": `Biometrics-module__width-100___QTzy9`,
	"cursorPointer": `Biometrics-module__cursor-pointer___GzfLg`,
	"cursorNotAllowed": `Biometrics-module__cursor-not-allowed___hFJ0H`,
	"absoluteCentered": `Biometrics-module__absolute-centered___VTfJ2`,
	"absolute": `Biometrics-module__absolute___gbW6y`,
	"relative": `Biometrics-module__relative___BZL89`,
	"fixed": `Biometrics-module__fixed___kjKGB`,
	"visible": `Biometrics-module__visible___GEv6S`,
	"invisible": `Biometrics-module__invisible____A1i7`,
	"col90": `Biometrics-module__col-90___ktrfj`,
	"colAuto": `Biometrics-module__col-auto___YNB5S`,
	"medicalTabs": `Biometrics-module__medical-tabs___xIzfv`,
	"medicalTableNew": `Biometrics-module__medical-table-new___mVN_g`,
	"noPagination": `Biometrics-module__no-pagination___ADBeN`,
	"medicalTableEmpty": `Biometrics-module__medical-table-empty___guJjK`,
	"iconBtn": `Biometrics-module__icon-btn___sgQsA`,
	"searchIcon": `Biometrics-module__search-icon___yg3JC`,
	"disableSelect": `Biometrics-module__disable-select___T1Q8h`,
	"breakWord": `Biometrics-module__break-word___vvPWf`,
	"popupClearBtn": `Biometrics-module__popup-clear-btn___iECWm`,
	"scrollMB20": `Biometrics-module__scroll-m-b-20___xcs3D`,
	"tabs": `Biometrics-module__tabs___WXUKo`,
	"empty": `Biometrics-module__empty___Wrscf`
};
module.exports = ___CSS_LOADER_EXPORT___;
